var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp-list"},[_vm._l((_vm.spList.slice(0, 5)),function(item,index){return [_c('SpItem',{key:index,attrs:{"spData":item}})]}),(_vm.showDiscoverMore)?_c('DiscoverMore'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }